'use client'

import React, { ReactNode } from 'react'
import { BugsnagConfig } from '@/utils/app/config'
import { getBugsnagClient } from '@/lib/bugsnag/client'

type ReactPluginType = {
  createErrorBoundary: (
    react: typeof React,
    opts?: unknown,
  ) => React.ComponentType<{ children: ReactNode }>
}

export type ErrorBoundaryProps = {
  config: BugsnagConfig
  children: ReactNode
}

const ErrorBoundary: React.ComponentType<ErrorBoundaryProps> = ({
  config,
  children,
}) => {
  const reactPlugin = getBugsnagClient(config).getPlugin('react') as
    | ReactPluginType
    | undefined

  const Fallback: React.ComponentType<{ children: ReactNode }> = ({
    children,
  }: {
    children: ReactNode
  }) => children

  const BugsnagErrorBoundary: React.ComponentType<{ children: ReactNode }> =
    reactPlugin?.createErrorBoundary(React) ?? Fallback

  return <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>
}

export default ErrorBoundary
